<div class="clutch-card" *ngIf="!showMultiKit">
  <div class="content">
    <div class="left">
      <div class="badges-top">
        <span class="badge light-orange">🔥 Fast Moving</span>
        <span class="badge light-yellow">⚡ 15 Min Dispatch</span>
      </div>
      <h2>🚗 Car Stuck? <br>Fix it in <span class="purple">90 mins⚡</span></h2>
      <p class="sub-text">No more waiting. Clutch kits ready near you.</p>
      <div class="badges">
        <!-- <span class="badge blue">⚡ 15 min dispatch</span> -->
        <span class="badge green">🚚 Free delivery</span>
        <span class="badge blue">🛡️ Warranty included</span>
        <div class="orange-main">
          <span class="badge orange">⏳ Only few kits left at JC Road</span>
        </div>
      </div>
      <div class="btn-get-clutch">
        <button class="top-btn" (click)="loadrequest()">⚡ Get Clutch Kit Now</button>
      </div>
      <p class="sub-text bottom-note">1-step order • No part selection needed</p>
    </div>

    <div class="right">
      <div class="image-box"><img src="../../../../assets/images/clutch-kit.webp"></div>
    </div>
  </div>
  <div class="brand-strip-section">
    <div class="brand-header">
      <div>
        <h3>Top Clutch Brands Available Instantly</h3>
        <p>Used by leading garages across India</p>
      </div>
      <span class="verified">✔ Verified Brands</span>
    </div>

    <div class="brand-slider">
      <div class="brand-track-wrapper" *ngIf="kitBrands?.length">
        <div class="brand-track">

          <ng-container *ngFor="let i of [1,2,3,4,5,6]">
            <div
              class="brand-item"
              *ngFor="let brand of kitBrands">
              <img [src]="brand" alt="Brand Logo">
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- ============================multiple kits ui================================= -->
<section class="ackui-wrapper" *ngIf="kits?.length > 0">
  <div class="ackui-container">

    <div class="ackui-left">
      <span class="ackui-eyebrow">Curated Repair Kits</span>

      <h1 class="ackui-headline">Repair Faster.<span class="ackui-headline__accent"> With Zero Guesswork.</span></h1>

      <p class="ackui-subtext">One intelligently bundled kit. Everything your garage needs. Ready in minutes.</p>

      <div class="ackui-kit-scroll-wrapper"  #multipleKitsSection >
        <button class="ackui-scroll-arrow ackui-scroll-arrow--prev" (click)="scrollKits(-1)"  [disabled]="isAtStart" aria-label="Previous kits">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <div class="ackui-kit-scroll" #kitScroll (scroll)="onKitScroll()">
          <div *ngFor="let kit of kits" class="ackui-kit-card" [class.ackui-kit-card--active]="isActive(kit)" (click)="selectKit(kit)">
            <div class="ackui-kit-card__check" *ngIf="isActive(kit)">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5l2.5 2.5 4.5-4.5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <div class="ackui-kit-card__img-wrap">
              <img class="ackui-kit-card__img"  [src]="kit.imageUrl || defaultImage"    [alt]="kit.title"   (error)="onKitImageError($event)">
            </div>
            <div class="ackui-kit-card__body">
              <h4 class="ackui-kit-card__title">{{ kit.title }}</h4>
              <p class="ackui-kit-card__desc">{{ kit.description }}</p>
              <span class="ackui-kit-card__badge" [ngClass]="'ackui-kit-card__badge--' + kit.badgeType">
                <span *ngIf="kit.badgeType === 'green'" class="ackui-kit-card__badge-icon">🛡️</span>
                {{ getDisplayTag(kit.tag) }}
              </span>
            </div>
          </div>
        </div>

        <button class="ackui-scroll-arrow ackui-scroll-arrow--next"  (click)="scrollKits(1)"  [disabled]="isAtEnd" aria-label="Next kits">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <!-- Dots -->
      <div class="ackui-scroll-dots">
        <span *ngFor="let dot of scrollDots; let i = index"
          class="ackui-scroll-dot"
          [class.ackui-scroll-dot--active]="activeDotIndex === i"
          (click)="scrollToDot(i)">
        </span>
      </div>

      <div class="ackui-cta-row">
        <button class="ackui-btn ackui-btn--primary" (click)="loadrequest()">⚡ Explore {{ selectedKit?.title }}<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
        <button class="ackui-btn ackui-btn--ghost" (click)="scrollToIncluded()">View all kits<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#0d1b3e" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
      </div>

      <div class="ackui-included">
        <p class="ackui-included__label">Included with this kit</p>
        <div class="ackui-included__grid">
          <div
            class="ackui-included__item"
            *ngFor="let item of includedIcons">

            <span class="ackui-included__icon">
              <img
                *ngIf="item.imageUrl"
                [src]="item.imageUrl"
                width="24">
                <span *ngIf="!item.imageUrl">⚡</span>
            </span>

            <div class="ackui-included__text">
              <strong>{{ item.title }}</strong>
              <span>{{ item.description }}</span>
            </div>

          </div>
        </div>
      </div>

      <!-- <div class="ackui-cta-row">
        <button class="ackui-btn ackui-btn--primary" (click)="loadrequest()">⚡ Explore {{ selectedKit?.title }}<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
        <button class="ackui-btn ackui-btn--ghost">View all kits<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#0d1b3e" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
      </div> -->
    </div>

    <div class="ackui-right">
      <div class="ackui-hero-visual">
        <img class="ackui-hero-visual__img" [src]="selectedKit?.banner?.imageUrl || defaultHeroImage" [alt]="selectedKit?.title + ' hero'" (error)="onKitImageError($event)">
      </div>
    </div>
  </div>
    <div class="brand-strip-section">
      <div class="brand-header">
        <div>
          
          <h3>Top {{ selectedKit?.title }} Brands Available Instantly</h3>
          <p>Used by leading garages across India</p>
        </div>
        <span class="verified">✔ Verified Brands</span>
      </div>

      <div class="brand-slider">
        <div class="brand-track-wrapper" *ngIf="kitBrands?.length">
          <div class="brand-track">
            <div class="brand-item" *ngFor="let brand of repeatedBrands">
              <img [src]="brand" alt="Brand Logo">
            </div>
          </div>
        </div>
      </div>
    </div>
</section>

<ng-template #intstantorder></ng-template>